const SERVICE_CODES = {
  MAINTEANCE: 'MAINTENANCE',
  REPAIR: 'REPAIR',
  TIRES: 'TIRES',
  APK: 'APK',
  CHECKS: 'CHECKS',
  DAMAGE: 'DAMAGE',
};

export const REPLACEMENT_TYPE = {
  none: 'none',
  message: 'message',
  wait: 'wait',
  bike: 'bike',
  car: 'car',
  transport: 'transport',
};

export const Categories = {
  POPULAR: 'Meest gekozen',
  CAMPAIGN: 'Ons advies',
  AIRCO: 'Airco',
  TIRES: 'Banden',
  DAMAGE: 'Schade',
  VACATION: 'Vakantie',
  OTHER: 'Overig',
};

export default SERVICE_CODES;
